import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import calculatorsData from '../calculators.json';

function HeroSection() {
  const [searchTerm, setSearchTerm] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const navigate = useNavigate();
  const [calculators, setCalculators] = useState([]);

  // Load calculators data
  useEffect(() => {
    setCalculators(calculatorsData);
  }, []);

  // Handle input change to filter suggestions
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchTerm(query);

    if (query) {
      const filteredSuggestions = calculators.filter(
        (calculator) =>
          calculator.name.toLowerCase().includes(query.toLowerCase()) // Case insensitive matching
      );
      setSuggestions(filteredSuggestions);
    } else {
      setSuggestions([]);
    }
  };

  // Handle suggestion click and navigate
  const handleSuggestionClick = (path) => {
    // Clear the input and suggestions when clicking a suggestion
    setSearchTerm('');
    setSuggestions([]);
    
    // Navigate to the selected path
    if (path) {
      navigate(path); // Use 'path' as per your data structure
    }
  };

  return (
    <section className="hero-section d-flex justify-content-center align-items-center" id="section_1">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-12 mx-auto">
            <h1 className="text-white text-center">Explore. Solve. Grow.</h1>
            <h6 className="text-center" style={{color: 'whitesmoke' }}>Your global hub for calculations and solutions</h6>
            <form className="custom-form mt-4 pt-2 mb-lg-0 mb-5" role="search">
              <div className="input-group input-group-lg">
                <span className="input-group-text bi-search" id="basic-addon1"></span>
                <input
                  name="keyword"
                  type="search"
                  className="form-control"
                  id="keyword"
                  placeholder="Search by Type of Calculators"
                  aria-label="Search"
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
                {/* <button type="submit" className="form-control">Search</button> */}
              </div>
              {/* Dropdown for suggestions */}
              {suggestions.length > 0 && (
                <ul className="dropdown-list">
                  {suggestions.map((suggestion, index) => (
                    <li 
                      key={index} 
                      className="dropdown-item" 
                      onClick={() => handleSuggestionClick(suggestion.path)} // Use 'path' for navigation
                      style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '17px' }}
                    >
                        <i className={suggestion.icon} style={{ color: '#13547a', marginRight: '13px' }}></i>
                       <strong>{suggestion.name}</strong>
                    </li>
                  ))}
                </ul>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
